var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSofaBed = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 30 30"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M23.031 12.203a1.313 1.313 0 0 0-1.312 1.313v1.312a.656.656 0 0 1-.657.656H7.938a.657.657 0 0 1-.656-.656v-1.312a1.313 1.313 0 0 0-2.625 0v2.625a2.625 2.625 0 0 0 2.625 2.625H21.72a2.625 2.625 0 0 0 2.625-2.625v-2.625a1.31 1.31 0 0 0-1.313-1.313M7.281 18.766v1.968M21.719 18.766v1.968"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#77838D",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.25,
  d: "M5.969 12.203a3.937 3.937 0 0 1 3.937-3.937h9.188a3.94 3.94 0 0 1 3.937 3.937M14.5 15.484V8.266"
})));
export default SvgSofaBed;